(function () {
  'use strict';

  var sbbNamespace = window.__SBB__ = window.__SBB__ || {};
  var ScaleBarBuilder = sbbNamespace.ScaleBarBuilder;
  var deepClone = sbbNamespace.deepClone;
  var clamp = sbbNamespace.clamp;
  var parseNumber = sbbNamespace.parseNumber;
  var infoOverlayDimmedOpacity = sbbNamespace.infoOverlayDimmedOpacity;
  var mmPerCm = sbbNamespace.mmPerCm;
  var shapeTypes = sbbNamespace.shapeTypes;
  var aprilTagFamilies = sbbNamespace.aprilTagFamilies;
  var circularFamilies = sbbNamespace.circularFamilies;
  var logoDataUrl = sbbNamespace.logoDataUrl;
  var fontOptions = sbbNamespace.fontOptions;
  var softwarePresets = sbbNamespace.softwarePresets;

  if (!ScaleBarBuilder || !deepClone || !clamp || !parseNumber || !shapeTypes || !aprilTagFamilies || !circularFamilies || !logoDataUrl || !fontOptions || !softwarePresets) {
    return;
  }

  var INFO_OVERLAY_DIMMED_OPACITY = infoOverlayDimmedOpacity;
  var MM_PER_CM = mmPerCm;
  var SHAPE_TYPES = shapeTypes;
  var APRILTAG_FAMILIES = aprilTagFamilies;
  var CIRCULAR_FAMILIES = circularFamilies;
  var LOGO_DATA_URL = logoDataUrl;
  var SOFTWARE_PRESETS = softwarePresets;


  ScaleBarBuilder.prototype.getCurrentPreset = function () {
    return SOFTWARE_PRESETS[this.state.softwarePreset] || SOFTWARE_PRESETS.generic;
  };


  ScaleBarBuilder.prototype.getFamilyOptionsForType = function (tagType, preset) {
    var presetConfig = preset || this.getCurrentPreset();
    var familyValues = (presetConfig.families && presetConfig.families[tagType]) || [];
    var familyOptions = tagType === 'apriltag' ? APRILTAG_FAMILIES : CIRCULAR_FAMILIES;
    var allowedMap = {};
    var output = [];

    familyValues.forEach(function (familyValue) {
      allowedMap[familyValue] = true;
    });

    for (var i = 0; i < familyOptions.length; i += 1) {
      if (allowedMap[familyOptions[i].value]) {
        output.push(familyOptions[i]);
      }
    }
    return output;
  };

  ScaleBarBuilder.prototype.getTagTypeForFamily = function (familyValue, preset) {
    var family = String(familyValue || '');
    if (!family) {
      return this.state && this.state.tagType ? this.state.tagType : 'apriltag';
    }
    var presetConfig = preset || this.getCurrentPreset();
    var allowedTypes = (presetConfig && presetConfig.allowedTypes) || ['apriltag', 'circular'];
    var i;
    var families;
    var j;

    for (i = 0; i < allowedTypes.length; i += 1) {
      families = this.getFamilyOptionsForType(allowedTypes[i], presetConfig);
      for (j = 0; j < families.length; j += 1) {
        if (families[j].value === family) {
          return allowedTypes[i];
        }
      }
    }
    return this.state && this.state.tagType ? this.state.tagType : 'apriltag';
  };

  ScaleBarBuilder.prototype.getFamilyOptionsForPreset = function (preset) {
    var presetConfig = preset || this.getCurrentPreset();
    var allowedTypes = (presetConfig && presetConfig.allowedTypes) || ['apriltag', 'circular'];
    var output = [];
    var i;
    var families;
    var j;

    for (i = 0; i < allowedTypes.length; i += 1) {
      families = this.getFamilyOptionsForType(allowedTypes[i], presetConfig);
      for (j = 0; j < families.length; j += 1) {
        output.push({
          value: families[j].value,
          label: families[j].label,
          tagType: allowedTypes[i]
        });
      }
    }
    return output;
  };


  ScaleBarBuilder.prototype.refreshPresetDependentOptions = function (forceDefaults) {
    this.validTagIdListCache = {};
    var preset = this.getCurrentPreset();
    var allowedTypes = preset.allowedTypes || ['apriltag', 'circular'];
    var allowedTypeMap = {};
    var i;

    for (i = 0; i < allowedTypes.length; i += 1) {
      allowedTypeMap[allowedTypes[i]] = true;
    }

    if (this.controls.tagType) {
      for (i = 0; i < this.controls.tagType.options.length; i += 1) {
        var typeOption = this.controls.tagType.options[i];
        typeOption.disabled = !allowedTypeMap[typeOption.value];
      }
    }

    if (forceDefaults || !allowedTypeMap[this.state.tagType]) {
      this.state.tagType = preset.defaultType || allowedTypes[0] || 'apriltag';
    }

    var families = this.getFamilyOptionsForPreset(preset);
    this.controls.tagFamily.innerHTML = '';
    var groupedFamilies = {};
    var typeGroupLabels = {
      apriltag: 'AprilTag families',
      circular: 'Circular targets'
    };

    for (i = 0; i < families.length; i += 1) {
      var familyType = families[i].tagType || 'apriltag';
      if (!Array.isArray(groupedFamilies[familyType])) {
        groupedFamilies[familyType] = [];
      }
      groupedFamilies[familyType].push(families[i]);
    }

    var hasRenderedGroup = false;
    for (i = 0; i < allowedTypes.length; i += 1) {
      var typeKey = allowedTypes[i];
      var typeFamilies = groupedFamilies[typeKey];
      if (!Array.isArray(typeFamilies) || typeFamilies.length === 0) {
        continue;
      }

      var groupHeaderOpt = document.createElement('option');
      groupHeaderOpt.disabled = true;
      groupHeaderOpt.textContent = '- ' + (typeGroupLabels[typeKey] || 'Targets') + ' -';
      this.controls.tagFamily.appendChild(groupHeaderOpt);

      for (var f = 0; f < typeFamilies.length; f += 1) {
        var familyOpt = document.createElement('option');
        familyOpt.value = typeFamilies[f].value;
        familyOpt.textContent = typeFamilies[f].label;
        this.controls.tagFamily.appendChild(familyOpt);
      }
      hasRenderedGroup = true;
    }

    var familyExists = false;
    for (i = 0; i < families.length; i += 1) {
      if (families[i].value === this.state.tagFamily) {
        familyExists = true;
        break;
      }
    }

    if (forceDefaults || !familyExists) {
      var preferredType = this.state.tagType;
      var presetDefaultFamily = preset.defaultFamily && preset.defaultFamily[preferredType];
      this.state.tagFamily = presetDefaultFamily || (families[0] && families[0].value) || '';
    }

    this.state.tagType = this.getTagTypeForFamily(this.state.tagFamily, preset);

    this.controls.softwarePreset.value = this.state.softwarePreset;
    if (this.controls.tagType) {
      this.controls.tagType.value = this.state.tagType;
    }
    this.controls.tagFamily.value = this.state.tagFamily;
    this.controls.presetNote.textContent = preset.note || '';
  };


  ScaleBarBuilder.prototype.computeAutoTagPositions = function () {
    var paper = this.getPaper();
    var points = [];
    var half = this.state.tagSizeMm / 2;
    var gridStepMm = this.getGridStepMm();
    var startX = paper.width / 2;
    var startY = paper.height / 2;

    if (this.state.corner !== 'center') {
      startX = this.state.cornerMarginMm + half;
      startY = this.state.cornerMarginMm + half;

      if (this.state.corner === 'top-right') {
        startX = paper.width - this.state.cornerMarginMm - half;
      }
      if (this.state.corner === 'bottom-left') {
        startY = paper.height - this.state.cornerMarginMm - half;
      }
      if (this.state.corner === 'bottom-right') {
        startX = paper.width - this.state.cornerMarginMm - half;
        startY = paper.height - this.state.cornerMarginMm - half;
      }
    } else if (this.state.tagCount > 1) {
      var spacingMm = this.state.spacingCm * MM_PER_CM;
      var totalDx = 0;
      var totalDy = 0;
      for (var c = 1; c < this.state.tagCount; c += 1) {
        var centerStep = this.state.steps[c - 1] || { axis: 'horizontal', dir: 1 };
        if (centerStep.axis === 'horizontal') {
          totalDx += centerStep.dir * spacingMm;
        } else {
          totalDy += centerStep.dir * spacingMm;
        }
      }
      startX -= totalDx / 2;
      startY -= totalDy / 2;
    }

    var printable = this.getPrintableRect(paper, half);
    startX = clamp(this.snapCenterToGrid(startX, gridStepMm, paper.width / 2), printable.minX, printable.maxX);
    startY = clamp(this.snapCenterToGrid(startY, gridStepMm, paper.height / 2), printable.minY, printable.maxY);

    points.push({ x: startX, y: startY });

    var spacingMm = this.state.spacingCm * MM_PER_CM;
    for (var i = 1; i < this.state.tagCount; i += 1) {
      var prev = points[i - 1];
      var step = this.state.steps[i - 1] || { axis: 'horizontal', dir: 1 };
      var nextPoint = { x: prev.x, y: prev.y };
      if (step.axis === 'horizontal') {
        nextPoint.x += step.dir * spacingMm;
      } else {
        nextPoint.y += step.dir * spacingMm;
      }
      nextPoint.x = clamp(this.snapCenterToGrid(nextPoint.x, gridStepMm, paper.width / 2), printable.minX, printable.maxX);
      nextPoint.y = clamp(this.snapCenterToGrid(nextPoint.y, gridStepMm, paper.height / 2), printable.minY, printable.maxY);
      points.push(nextPoint);
    }

    return points;
  };


  ScaleBarBuilder.prototype.ensureTagCollection = function (forceAutoSync) {
    var i;
    if (!Array.isArray(this.state.tags)) {
      this.state.tags = [];
    }

    var autoPoints = this.computeAutoTagPositions();

    for (i = 0; i < this.state.tagCount; i += 1) {
      if (!this.state.tags[i]) {
        this.state.tags[i] = {
          id: i,
          xMm: autoPoints[i] ? autoPoints[i].x : 10 + i * 20,
          yMm: autoPoints[i] ? autoPoints[i].y : 10
        };
      }
    }

    this.state.tags.length = this.state.tagCount;
    this.ensureTagSizes();

    if (this.state.layoutMode === 'auto' || forceAutoSync) {
      for (i = 0; i < this.state.tagCount; i += 1) {
        this.state.tags[i].xMm = autoPoints[i].x;
        this.state.tags[i].yMm = autoPoints[i].y;
        this.state.tagSizesMm[i] = clamp(parseNumber(this.state.tagSizesMm[i], this.state.tagSizeMm), 8, 180);
      }
    }

    this.state.originTagIndex = clamp(
      Math.round(parseNumber(this.state.originTagIndex, 0)),
      0,
      Math.max(0, this.state.tagCount - 1)
    );
    this.ensureHomePoint();

    this.resolveUniqueViableTagIds();
  };


  ScaleBarBuilder.prototype.resolveUniqueViableTagIds = function () {
    var usedIds = {};
    var reservedIds = this.getReservedTagIdMapForCurrentScope();
    var idBounds = this.getCurrentTagIdBounds(this.state.tagType, this.state.tagFamily);
    var minTagId = idBounds.min;
    var maxTagId = idBounds.max;
    var i;
    this.idCorrections = [];
    for (i = 0; i < this.state.tagCount; i += 1) {
      var rawId = clamp(Math.round(parseNumber(this.state.tags[i].id, minTagId + i)), minTagId, maxTagId);
      var finalId = this.findNextUniqueViableTagId(rawId, usedIds, reservedIds);
      usedIds[finalId] = true;
      if (finalId !== rawId) {
        this.idCorrections.push({
          index: i + 1,
          from: rawId,
          to: finalId
        });
      }
      this.state.tags[i].id = finalId;
    }
  };


  ScaleBarBuilder.prototype.initDefaultOverlays = function () {
    var infoItem = {
      id: this.infoOverlayId,
      type: 'info',
      xMm: 6,
      yMm: null,
      wMm: 0,
      hMm: 0,
      rotationDeg: 0,
      zIndex: 30,
      locked: true,
      visible: true,
      opacity: 1
    };

    var logoItem = {
      id: this.logoOverlayId,
      type: 'logo',
      xMm: 0,
      yMm: 0,
      wMm: 17,
      hMm: 11.5,
      rotationDeg: 0,
      zIndex: 20,
      locked: true,
      visible: true,
      opacity: 1,
      srcDataUrl: LOGO_DATA_URL,
      preserveAspect: true
    };

    this.state.overlayItems = [logoItem, infoItem];
  };


  ScaleBarBuilder.prototype.findOverlayById = function (id) {
    for (var i = 0; i < this.state.overlayItems.length; i += 1) {
      if (this.state.overlayItems[i].id === id) {
        return this.state.overlayItems[i];
      }
    }
    return null;
  };


  ScaleBarBuilder.prototype.getInfoOverlay = function () {
    return this.findOverlayById(this.infoOverlayId);
  };


  ScaleBarBuilder.prototype.ensureHomePoint = function () {
    var paper = this.getPaper();
    var firstTag = (Array.isArray(this.state.tags) && this.state.tags.length) ? this.state.tags[0] : null;
    var fallbackX = firstTag ? parseNumber(firstTag.xMm, paper.width / 2) : (paper.width / 2);
    var fallbackY = firstTag ? parseNumber(firstTag.yMm, paper.height / 2) : (paper.height / 2);
    if (!this.state.homePoint || typeof this.state.homePoint !== 'object') {
      this.state.homePoint = {
        xMm: clamp(fallbackX, 0, paper.width),
        yMm: clamp(fallbackY, 0, paper.height),
        visible: true
      };
      return this.state.homePoint;
    }
    this.state.homePoint.xMm = clamp(parseNumber(this.state.homePoint.xMm, fallbackX), 0, paper.width);
    this.state.homePoint.yMm = clamp(parseNumber(this.state.homePoint.yMm, fallbackY), 0, paper.height);
    this.state.homePoint.visible = this.state.homePoint.visible !== false;
    return this.state.homePoint;
  };


  ScaleBarBuilder.prototype.getHomePoint = function () {
    return this.ensureHomePoint();
  };


  ScaleBarBuilder.prototype.resetHomePoint = function () {
    var paper = this.getPaper();
    var firstTag = (Array.isArray(this.state.tags) && this.state.tags.length) ? this.state.tags[0] : null;
    this.state.homePoint = {
      xMm: clamp(firstTag ? parseNumber(firstTag.xMm, paper.width / 2) : (paper.width / 2), 0, paper.width),
      yMm: clamp(firstTag ? parseNumber(firstTag.yMm, paper.height / 2) : (paper.height / 2), 0, paper.height),
      visible: true
    };
    this.state.homeSetMode = false;
  };


  ScaleBarBuilder.prototype.startHomeSetMode = function () {
    if (this.state.homeSetMode) {
      this.state.homeSetMode = false;
      this.setStatus('HOME placement cancelled.', false);
      this.render();
      return;
    }
    this.ensureHomePoint();
    this.state.homeSetMode = true;
    this.state.selectedEntity = { type: 'home', id: 'home' };
    this.setStatus('Click in the canvas to place HOME.', false);
    this.render();
  };


  ScaleBarBuilder.prototype.isInfoOverlayDimmed = function () {
    var info = this.getInfoOverlay();
    if (!info) {
      return false;
    }
    if (info.visible === false) {
      return true;
    }
    return parseNumber(info.opacity, 1) <= (INFO_OVERLAY_DIMMED_OPACITY + 0.001);
  };


  ScaleBarBuilder.prototype.setInfoOverlayDimmed = function (dimmed) {
    var info = this.getInfoOverlay();
    if (!info) {
      return false;
    }
    if (dimmed) {
      info.visible = false;
      info.opacity = INFO_OVERLAY_DIMMED_OPACITY;
    } else {
      info.visible = true;
      info.opacity = 1;
    }
    return true;
  };


  ScaleBarBuilder.prototype.toggleInfoOverlayDimmed = function () {
    return this.setInfoOverlayDimmed(!this.isInfoOverlayDimmed());
  };


  ScaleBarBuilder.prototype.addShapeOverlay = function (shapeKind) {
    var paper = this.getPaper();
    var kind = 'rectangle';
    for (var i = 0; i < SHAPE_TYPES.length; i += 1) {
      if (SHAPE_TYPES[i].value === shapeKind) {
        kind = shapeKind;
        break;
      }
    }
    var id = 'overlay-shape-' + this.overlayCounter;
    this.overlayCounter += 1;
    var item = {
      id: id,
      type: 'shape',
      shapeKind: kind,
      xMm: 0,
      yMm: 0,
      wMm: 24,
      hMm: 12,
      rotationDeg: 0,
      zIndex: 23,
      locked: false,
      visible: true,
      opacity: 1,
      fillColor: '#000000',
      strokeColor: '#000000',
      strokeWidthMm: 0.4,
      rows: 4,
      cols: 4,
      ringCount: 3,
      spokeCount: 8,
      armRatio: 0.24,
      showCoordinates: false
    };
    if (kind === 'circle' || kind === 'circle-quartered') {
      item.wMm = 20;
      item.hMm = 20;
    } else if (kind === 'line') {
      item.wMm = 30;
      item.hMm = 0.8;
    } else if (kind === 'grid') {
      item.wMm = 24;
      item.hMm = 16;
    } else if (kind === 'circle-grid') {
      item.wMm = 24;
      item.hMm = 24;
    } else if (kind === 'compass-marker') {
      item.wMm = 22;
      item.hMm = 34;
    } else if (kind === 'cross') {
      item.wMm = 20;
      item.hMm = 20;
    }
    var centerXmm = Number.isFinite(this.state.viewCenterXmm) ? this.state.viewCenterXmm : (paper.width / 2);
    var centerYmm = Number.isFinite(this.state.viewCenterYmm) ? this.state.viewCenterYmm : (paper.height / 2);
    item.xMm = centerXmm - item.wMm / 2;
    item.yMm = centerYmm - item.hMm / 2;
    this.clampOverlayToPrintable(item, paper);
    this.state.overlayItems.push(item);
    this.state.selectedEntity = { type: 'overlay', id: item.id };
    this.render();
    this.commitHistory();
  };


  ScaleBarBuilder.prototype.addTextOverlay = function () {
    var paper = this.getPaper();
    var id = 'overlay-text-' + this.overlayCounter;
    this.overlayCounter += 1;
    var item = {
      id: id,
      type: 'text',
      xMm: paper.width * 0.4,
      yMm: paper.height * 0.5,
      wMm: 40,
      hMm: 12,
      rotationDeg: 0,
      zIndex: 25,
      locked: false,
      visible: true,
      opacity: 1,
      text: 'Text',
      fontFamily: this.state.defaultFontFamily,
      fontSizePt: 14,
      color: '#000000',
      align: 'left'
    };
    this.state.overlayItems.push(item);
    this.state.selectedEntity = { type: 'overlay', id: item.id };
    this.render();
    this.commitHistory();
  };


  ScaleBarBuilder.prototype.addImageOverlayFromFile = function (file) {
    var self = this;
    if (!file) {
      return;
    }

    var reader = new FileReader();
    reader.onload = function () {
      var src = String(reader.result || '');
      if (!src) {
        return;
      }
      var id = 'overlay-image-' + self.overlayCounter;
      self.overlayCounter += 1;
      var paper = self.getPaper();
      var item = {
        id: id,
        type: 'image',
        xMm: paper.width * 0.45,
        yMm: paper.height * 0.45,
        wMm: 38,
        hMm: 24,
        rotationDeg: 0,
        zIndex: 24,
        locked: false,
        visible: true,
        opacity: 1,
        srcDataUrl: src,
        preserveAspect: true
      };
      self.state.overlayItems.push(item);
      self.state.selectedEntity = { type: 'overlay', id: item.id };
      self.setStatus('Image overlay added.');
      self.render();
      self.commitHistory();
    };
    reader.readAsDataURL(file);
  };


  ScaleBarBuilder.prototype.addImageOverlayFromUrl = function (url) {
    var src = String(url || '').trim();
    if (!src) {
      return false;
    }
    if (!/^https?:\/\//i.test(src)) {
      this.setStatus('Image URL must start with http:// or https://', true);
      return false;
    }
    var paper = this.getPaper();
    var id = 'overlay-image-' + this.overlayCounter;
    this.overlayCounter += 1;
    var item = {
      id: id,
      type: 'image',
      xMm: paper.width * 0.45,
      yMm: paper.height * 0.45,
      wMm: 38,
      hMm: 24,
      rotationDeg: 0,
      zIndex: 24,
      locked: false,
      visible: true,
      opacity: 1,
      srcDataUrl: src,
      preserveAspect: true
    };
    this.state.overlayItems.push(item);
    this.state.selectedEntity = { type: 'overlay', id: item.id };
    this.setStatus('Image URL added. Note: export depends on remote image CORS permissions.');
    this.render();
    this.commitHistory();
    return true;
  };


  ScaleBarBuilder.prototype.isImagePickerOpen = function () {
    return !!(this.controls.imagePickerOverlay && !this.controls.imagePickerOverlay.hidden);
  };


  ScaleBarBuilder.prototype.cleanupImagePickerPreviewUrl = function () {
    if (!this.imagePickerState || !this.imagePickerState.previewObjectUrl) {
      return;
    }
    if (typeof URL !== 'undefined' && typeof URL.revokeObjectURL === 'function') {
      try {
        URL.revokeObjectURL(this.imagePickerState.previewObjectUrl);
      } catch (error) {
        // ignore revocation errors
      }
    }
    this.imagePickerState.previewObjectUrl = '';
  };


  ScaleBarBuilder.prototype.setImagePickerStatus = function (message, isError) {
    if (!this.controls.imagePickerStatus) {
      return;
    }
    this.controls.imagePickerStatus.textContent = String(message || '');
    this.controls.imagePickerStatus.classList.toggle('is-error', !!isError);
  };


  ScaleBarBuilder.prototype.updateImagePickerInsertState = function () {
    if (!this.controls.imagePickerInsert) {
      return;
    }
    var st = this.imagePickerState || {};
    var canInsert = false;
    if (st.sourceType === 'upload' && st.file && st.previewValid) {
      canInsert = true;
    } else if (st.sourceType === 'url' && st.sourceValue && st.previewValid) {
      canInsert = true;
    }
    this.controls.imagePickerInsert.disabled = !canInsert;
  };


  ScaleBarBuilder.prototype.setImagePickerMode = function (mode) {
    if (!this.imagePickerState) {
      return;
    }
    var nextMode = mode === 'url' ? 'url' : 'upload';
    this.imagePickerState.mode = nextMode;
    if (this.controls.imagePickerModeUpload) {
      this.controls.imagePickerModeUpload.classList.toggle('active', nextMode === 'upload');
    }
    if (this.controls.imagePickerModeUrl) {
      this.controls.imagePickerModeUrl.classList.toggle('active', nextMode === 'url');
    }
    if (this.controls.imagePickerUploadPanel) {
      this.controls.imagePickerUploadPanel.hidden = nextMode !== 'upload';
    }
    if (this.controls.imagePickerUrlPanel) {
      this.controls.imagePickerUrlPanel.hidden = nextMode !== 'url';
    }
    if (nextMode === 'upload') {
      this.setImagePickerStatus('Local uploads are not persisted in templates/share links.', false);
      if (this.controls.imagePickerFile) {
        this.controls.imagePickerFile.focus();
      }
    } else {
      this.setImagePickerStatus('URL images persist in templates/share links.', false);
      if (this.controls.imagePickerUrlInput) {
        this.controls.imagePickerUrlInput.focus();
      }
    }
    this.updateImagePickerInsertState();
  };


  ScaleBarBuilder.prototype.resetImagePickerPreview = function () {
    this.cleanupImagePickerPreviewUrl();
    if (this.controls.imagePickerPreview) {
      this.controls.imagePickerPreview.hidden = true;
      this.controls.imagePickerPreview.removeAttribute('src');
    }
    if (this.controls.imagePickerPreviewEmpty) {
      this.controls.imagePickerPreviewEmpty.hidden = false;
    }
    this.imagePickerState.previewValid = false;
    this.updateImagePickerInsertState();
  };


  ScaleBarBuilder.prototype.updateImagePickerPreview = function (src, sourceType, sourceValue) {
    if (!this.controls.imagePickerPreview) {
      return;
    }
    var self = this;
    this.imagePickerState.sourceType = sourceType || null;
    this.imagePickerState.sourceValue = String(sourceValue || '');
    this.imagePickerState.previewValid = false;
    this.updateImagePickerInsertState();
    if (this.controls.imagePickerPreviewEmpty) {
      this.controls.imagePickerPreviewEmpty.hidden = true;
    }
    this.controls.imagePickerPreview.hidden = false;
    this.controls.imagePickerPreview.onload = function () {
      self.imagePickerState.previewValid = true;
      self.updateImagePickerInsertState();
      self.setImagePickerStatus(sourceType === 'upload'
        ? 'Preview ready. Local uploads are not persisted in templates/share links.'
        : 'Preview ready. URL image will be persisted in templates/share links.', false);
    };
    this.controls.imagePickerPreview.onerror = function () {
      self.imagePickerState.previewValid = false;
      self.updateImagePickerInsertState();
      self.setImagePickerStatus('Unable to preview that image source.', true);
    };
    this.controls.imagePickerPreview.src = src;
  };


  ScaleBarBuilder.prototype.handleImagePickerFileChange = function (file) {
    if (!file) {
      this.imagePickerState.file = null;
      this.resetImagePickerPreview();
      this.setImagePickerStatus('Choose a local image file to preview.', false);
      return;
    }
    this.cleanupImagePickerPreviewUrl();
    var objectUrl = '';
    if (typeof URL !== 'undefined' && typeof URL.createObjectURL === 'function') {
      try {
        objectUrl = URL.createObjectURL(file);
      } catch (error) {
        objectUrl = '';
      }
    }
    this.imagePickerState.file = file;
    if (objectUrl) {
      this.imagePickerState.previewObjectUrl = objectUrl;
      this.updateImagePickerPreview(objectUrl, 'upload', file.name || '');
    } else {
      var self = this;
      var reader = new FileReader();
      reader.onload = function () {
        var result = String(reader.result || '');
        if (!result) {
          self.setImagePickerStatus('Unable to preview selected file.', true);
          return;
        }
        self.updateImagePickerPreview(result, 'upload', file.name || '');
      };
      reader.onerror = function () {
        self.setImagePickerStatus('Unable to read selected file.', true);
      };
      reader.readAsDataURL(file);
    }
  };


  ScaleBarBuilder.prototype.handleImagePickerUrlPreview = function () {
    var value = this.controls.imagePickerUrlInput ? String(this.controls.imagePickerUrlInput.value || '').trim() : '';
    if (!value) {
      this.setImagePickerStatus('Paste an image URL to preview.', true);
      this.resetImagePickerPreview();
      return;
    }
    if (!/^https?:\/\//i.test(value)) {
      this.setImagePickerStatus('Image URL must start with http:// or https://', true);
      this.resetImagePickerPreview();
      return;
    }
    this.imagePickerState.file = null;
    this.cleanupImagePickerPreviewUrl();
    this.updateImagePickerPreview(value, 'url', value);
  };


  ScaleBarBuilder.prototype.openImagePickerModal = function () {
    if (!this.controls.imagePickerOverlay) {
      this.setStatus('Image picker is unavailable in this template.', true);
      return;
    }
    this.imagePickerState.sourceType = null;
    this.imagePickerState.sourceValue = '';
    this.imagePickerState.file = null;
    this.resetImagePickerPreview();
    if (this.controls.imagePickerFile) {
      this.controls.imagePickerFile.value = '';
    }
    if (this.controls.imagePickerUrlInput) {
      this.controls.imagePickerUrlInput.value = '';
    }
    this.controls.imagePickerOverlay.hidden = false;
    this.setImagePickerMode('upload');
  };


  ScaleBarBuilder.prototype.closeImagePickerModal = function () {
    if (!this.controls.imagePickerOverlay) {
      return;
    }
    this.controls.imagePickerOverlay.hidden = true;
    this.imagePickerState.sourceType = null;
    this.imagePickerState.sourceValue = '';
    this.imagePickerState.file = null;
    this.resetImagePickerPreview();
    if (this.controls.imagePickerFile) {
      this.controls.imagePickerFile.value = '';
    }
    if (this.controls.imagePickerUrlInput) {
      this.controls.imagePickerUrlInput.value = '';
    }
    this.setImagePickerStatus('', false);
  };


  ScaleBarBuilder.prototype.confirmImagePickerInsert = function () {
    if (!this.imagePickerState) {
      return;
    }
    if (this.imagePickerState.sourceType === 'upload' && this.imagePickerState.file && this.imagePickerState.previewValid) {
      var file = this.imagePickerState.file;
      this.closeImagePickerModal();
      this.addImageOverlayFromFile(file);
      return;
    }
    if (this.imagePickerState.sourceType === 'url' && this.imagePickerState.sourceValue && this.imagePickerState.previewValid) {
      if (this.addImageOverlayFromUrl(this.imagePickerState.sourceValue)) {
        this.closeImagePickerModal();
      }
      return;
    }
    this.setImagePickerStatus('Preview an image source before inserting.', true);
  };


  ScaleBarBuilder.prototype.promptAddImageSource = function () {
    this.openImagePickerModal();
  };


  ScaleBarBuilder.prototype.switchToManualMode = function () {
    if (this.state.layoutMode === 'manual') {
      return;
    }
    this.ensureTagCollection(true);
    this.state.layoutMode = 'manual';
    this.syncControlsFromState();
  };


  ScaleBarBuilder.prototype.deleteTagAtIndex = function (index) {
    if (this.state.tagCount <= 1) {
      this.setStatus('At least one tag is required.', true);
      return;
    }
    if (!Number.isFinite(index) || index < 0 || index >= this.state.tagCount) {
      return;
    }

    this.state.tags.splice(index, 1);
    if (Array.isArray(this.state.tagSizesMm)) {
      this.state.tagSizesMm.splice(index, 1);
    }
    this.state.tagCount -= 1;
    this.controls.tagCount.value = this.state.tagCount;

    if (this.state.originTagIndex === index) {
      this.state.originTagIndex = Math.max(0, index - 1);
    } else if (this.state.originTagIndex > index) {
      this.state.originTagIndex -= 1;
    }

    if (this.state.layoutMode === 'auto') {
      this.ensureTagCollection(true);
    } else {
      this.ensureTagCollection(false);
    }

    if (this.state.selectedEntity && this.state.selectedEntity.type === 'tag') {
      if (this.state.selectedEntity.id === index) {
        this.state.selectedEntity = null;
      } else if (this.state.selectedEntity.id > index) {
        this.state.selectedEntity.id -= 1;
      }
    }

    this.syncControlsFromState();
    this.syncDynamicRows();
    this.render();
    this.commitHistory();
  };

})();
